const state = {
    filterSearchObj:null,
  
    filterRoute:null,
    bookingListRes:null,
    ticketRefundObj:null,
    ticketExchangeObj:null,
    tableWatchList:null

};

const getters = {
  
    GET_FILTER_SEARCH_OBJ: (state) => {
        return state.filterSearchObj;
    },
    GET_FILTER_ROUTE: (state) => {
        return state.filterRoute;
    },
    GET_BOOKING_LIST_RES: (state) => {
        return state.bookingListRes;
    },

    GET_TKT_REFUND_OBJ:(state)=>{

        return state.ticketRefundObj;
    },

    GET_TKT_EXCHANGE_OBJ:(state)=>{


        return state.ticketExchangeObj

    }
    ,
    GET_TABLE_WATCH_LIST: (state) => {
        return state.tableWatchList;
    },



};


const actions = {

    CLEAR_BOOKING_DETAIL_STORE: ({ commit }) => {
        commit('clearBookingDetailStore');
    },

    
  

    SET_FILTER_SEARCH_OBJ: ({ commit }, req) => {

        commit('saveFilterSearchObj', req);

    },
   
    SET_FILTER_ROUTE: ({ commit }, req) => {

        commit('saveFilterRoute', req);

    },

    SET_BOOKING_LIST_RES: ({ commit }, req) => {

        commit('saveBookingListRes', req);

    },

    SET_TKT_REFUND_OBJ:({commit},obj)=>{
        commit('saveTktRefundObj',obj)
    },
    SET_TKT_EXCHANGE_OBJ:({commit},obj)=>{
         commit('saveTktExchangeObj',obj)
    }
    ,
    SET_TABLE_WATCH_LIST:({commit},activeObj)=>{
        commit('saveTableWatchList',activeObj)
   }
};


const mutations = {
    clearBookingDetailStore: (state) => {
     
      
        state.filterSearchObj = null;

        state.filterRoute =null;
        state.bookingListRes =null;
        state.tableWatchList=null;
     


    },
   
   
    saveFilterSearchObj: (state, req) => {
        state.filterSearchObj = req;
    },
    saveFilterRoute: (state, req) => {
        state.filterRoute = req;
    },
    saveBookingListRes: (state, req) => {
        state.bookingListRes = req;
    },


    saveTktRefundObj:(state,obj)=>{
        state.ticketRefundObj=obj;
    },

    saveTktExchangeObj:(state,obj)=>{
        state.ticketExchangeObj=obj
    }
     ,
     saveTableWatchList:(state,activeObj)=>{
        state.tableWatchList=activeObj;
    }

};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}